import { render, staticRenderFns } from "./FakeCheckboxComponent.vue?vue&type=template&id=24609f64&"
import script from "./FakeCheckboxComponent.vue?vue&type=script&lang=js&"
export * from "./FakeCheckboxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports